import React, { useState } from 'react';
import { useHistory } from "react-router";
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles,withStyles ,createStyles} from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Grid,
  Chip,
  FormGroup,
  FormControlLabel,
  Button,
  Radio,
  RadioGroup,
  FormControl
} from '@material-ui/core';
import CustomDialog from '../../../components/Notifications/Dialog';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { AdjustmentService } from '../../../services';
import AdjustmentData from '../AdjustmentData';

//import { getInitials } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    //minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  success:{
    backgroundColor:theme.palette.success.main
  }
}));

const AdjustmentTable = props => {
  const { className, dataTable_Adjustment, onChangeOrderBy, onChangePage, onChangeTable,loader,length,onSelectRow, ...rest } = props;

  const history = useHistory();
  // const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('EmployeeCode');
  const [itemSelect,setItemSelect] = useState(null);
  const [isOpenViewFileComplete,setIsOpenViewFileComplete] = useState(false);

  const [isPrintAdjust,setIsPrintAdjust] = useState(false);
  const [isPrintReservedAdjust,setIsPrintReservedAdjust] = useState(false);
  const [hasPrintHeader,setHasPrintHeader] = useState(true);
  const [openLoading, setOpenLoading] = React.useState(false);

  const handleViewFile = (item) => {
    setIsPrintAdjust(false)
    setIsPrintReservedAdjust(false)
    setItemSelect(item);
    setIsOpenViewFileComplete(true)
  };

  const handleOnClickPreviewComplete = () =>{

    if(isPrintAdjust === true || isPrintReservedAdjust === true)
    {
      setIsOpenViewFileComplete(false);
        setOpenLoading(true)
        if(isPrintAdjust === true)
        {
            //hasPrintHeader
            if(itemSelect.status === 'BCFM'|| itemSelect.status == "ACCEPT" || itemSelect.status == "COMPLETE")
            {
                AdjustmentService.getCreatePDFAdjustmentDetail({'id':itemSelect.adjustment_id,'type':'adjust',
                'filename':itemSelect.product_type === 'C' ? AdjustmentData.fileNameAdjustment_C(itemSelect.po_contract_no) : AdjustmentData.fileNameAdjustment_G(itemSelect.po_contract_no)
                ,'template': hasPrintHeader? 'adjustment':'adjustment_none_header','body':'','title':''}).then((response)=>{
                  
                    setOpenLoading(false)
                });
            }else{
              AdjustmentService.getCreatePDFAdjustmentDetail({'id':itemSelect.adjustment_id,'type':'adjust',
              'filename':itemSelect.product_type === 'C' ? AdjustmentData.fileNameAdjustment_C(itemSelect.po_contract_no) : AdjustmentData.fileNameAdjustment_G(itemSelect.po_contract_no)
                ,'template': hasPrintHeader? 'adjustment_draft':'adjustment_draft_none_header','body':'','title':''}).then((response)=>{
                
                    setOpenLoading(false)
                });
            }
           
        }else{
            console.log('isPrintAdjust', isPrintAdjust)
        }

        if(isPrintReservedAdjust === true)
        {
            if(itemSelect.status === 'BCFM'|| itemSelect.status == "ACCEPT" || itemSelect.status == "COMPLETE")
            {
                AdjustmentService.getCreatePDFAdjustmentDetail({'id':itemSelect.adjustment_id,'type':'reserved_adjust',
                'filename':itemSelect.product_type === 'C' ? AdjustmentData.fileNameReservedAdjustment_C(itemSelect.po_contract_no) : AdjustmentData.fileNameReservedAdjustment_G(itemSelect.po_contract_no)
                ,'template':hasPrintHeader? 'adjustment':'adjustment_none_header','body':'','title':''}).then((response)=>{
                 
                    setOpenLoading(false)
                });
            }else{
              AdjustmentService.getCreatePDFAdjustmentDetail({'id':itemSelect.adjustment_id,'type':'reserved_adjust',
              'filename':itemSelect.product_type === 'C' ? AdjustmentData.fileNameReservedAdjustment_C(itemSelect.po_contract_no) : AdjustmentData.fileNameReservedAdjustment_G(itemSelect.po_contract_no)
              ,'template':hasPrintHeader? 'adjustment_draft':'adjustment_draft_none_header','body':'','title':''}).then((response)=>{
                
                
                  setOpenLoading(false)
              });
            }
        }else{
            console.log('isPrintReservedAdjust', isPrintReservedAdjust,isPrintReservedAdjust)
        }
    }else{
      console.log('handleOnClickPreviewComplete', isPrintAdjust)
    }
  }

  const handlePageChange = (event, _page) => {
    setPage(_page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  const handleRequestSort = (event, property) => {
    let dir = property!== orderBy?order: order==='asc'?'desc':'asc';
    setOrder(dir)
    setOrderBy(property)
    dataTable_Adjustment.sort(compareValues(property, dir))
  };

  const handleSelectRow = (property, obj) => {
    if(onSelectRow)
    {
      onSelectRow(property, obj);
    }
  };

  function compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0;
      }
  
      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];
  
      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  const handlerEditClick = (index, adjustmentId) => {
    history.push(`/AdjustmentDetail/${adjustmentId}`);
  };

  const toBoolean = (value) =>{
    if (value === 1)
        return true
    else if (value === true)
        return true
    else
        return false
  }

  function IsShowsLoading(props) {
    const { isLoading } = props;
    return (
        (isLoading ?
            <div id="loading-element">
                <div id="loading-indicator">
                    <div className="lds-ripple"><div></div><div></div></div>
                </div>
            </div>
            : null)
    )
}

  return (
    <Grid container>
      <Grid item xs={12}>
        <IsShowsLoading isLoading={openLoading} ></IsShowsLoading>
        <Table className="sp-table table rrs-table">
          <TableHead>
            <TableRow className="sp-table-header">
              <TableCell className="th-table text-center" style={{ width: '50px' }}>PO/Contract No.
              </TableCell>
              <TableCell className="th-table text-center" style={{ width: '50px' }}>งวดที่
                </TableCell>
              <TableCell className="th-table text-center" >Header
                Text</TableCell>
              <TableCell className="th-table text-center" style={{ width: '200px' }}>Create
                By</TableCell>
              <TableCell className="th-table text-center" style={{ width: '50px' }}>Create
                Date</TableCell>
              <TableCell className="th-table text-center"
                style={{ width: '150px' }}>Status</TableCell>
              <TableCell className="th-table text-center"
                style={{ width: '50px' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              dataTable_Adjustment ? (
                dataTable_Adjustment.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((data, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="text-center">{data.po_contract_no}</TableCell>
                        <TableCell className="text-center">{data.installment_no}</TableCell>
                        <TableCell className="text-left">{data.po_header_text}</TableCell>
                        <TableCell className="text-left">{data.create_by} {data.create_by_name}</TableCell>
                        <TableCell className="text-center">{data.create_date ? moment(data.create_date).format('DD/MM/YYYY') : ''}</TableCell>
                        <TableCell className="text-center">{data.status_name}</TableCell>
                        <TableCell className="text-center" style={{ display: 'flex', justifyContent: 'left', alignContent: 'center' }}>
                          <a onClick={() => handlerEditClick(index, data.adjustment_id)}
                            style={{ cursor: 'pointer', }} title="View">
                            <i className="icon icon-preview-eye-blue" />
                          </a>

                          <a onClick={() => handleViewFile(data)}
                            style={{ cursor: 'pointer', marginLeft: 10 }}  title="Print">
                            <i className="icon icon-preview-pdf" />
                          </a>

                          {data.isReadonly === false && data.product_type === 'G' && data.is_reserved_adjust !== true &&
                          (data.status === 'DRAFT' || data.status === 'REJECT') &&

                            <a onClick={() => handlerEditClick(index, data.adjustment_id)}
                              style={{ cursor: 'pointer', marginLeft: 10 }} title="หนังสือแจ้งสงวนสิทธิ์การปรับ">
                              <i className="icon btn-plus" />
                            </a>
                          }
                        </TableCell>
                      </TableRow>
                    )
                  })) : (
                <TableRow key={0}>
                  <TableCell colSpan="11" className="text-center" style={{
                    textAlign: 'center',
                    fontStyle: 'italic',
                    color: 'gray',
                  }}>No data</TableCell>
                </TableRow>
              )
            }
          </TableBody>
        </Table>
      </Grid>
      <Grid item xs={12}>
        <TablePagination
          //component="div"
          count={dataTable_Adjustment ? dataTable_Adjustment.length : 0 }
          //onChangePage={handlePageChange}
          onPageChange={handlePageChange}
          //onChangeRowsPerPage={handleRowsPerPageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[2, 5, 10, 25]}
        />
      </Grid>
      <Grid item>
        <CustomDialog open={isOpenViewFileComplete} title={"Print หนังสือเกี่ยวข้องกับการปรับ"} maxWidth="sm"
                onClose={()=>{
                    setIsOpenViewFileComplete(false)
                }}
                >
                    <Grid container  style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center">
                        <Grid item xs={12} style={{textAlign:'center'}}>
                            <FormControl>
                                <RadioGroup row aria-label="gender" name="row-radio-buttons-group" spacing={2}>
                                <Button color="primary" variant={hasPrintHeader ? "contained" :"outlined"} style={{marginRight:5}}><FormControlLabel value="header" style={{marginBottom:0}} control={<Radio style={{color: hasPrintHeader ? '#ffffff' : '#3f51b5'}} checked={hasPrintHeader}
                                    onChange={()=>{setHasPrintHeader(true)}}
                                    />} label="แบบมี Header/Footer" /></Button>
                                <Button color="primary" variant={!hasPrintHeader ? "contained" :"outlined"}><FormControlLabel value="noneheader" style={{marginBottom:0}} control={<Radio  style={{color: !hasPrintHeader ? '#ffffff' : '#3f51b5'}} checked={!hasPrintHeader}
                                    onChange={()=>{setHasPrintHeader(false)}}
                                    />} label="แบบไม่มี Header/Footer" /></Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <p>&nbsp;</p>
                        </Grid>
                        { itemSelect && <Grid item xs={12} sm={6}>
                            <FormGroup>
                                { toBoolean(itemSelect.is_adjust) && <FormControlLabel control={<Checkbox color="primary" defaultValue={isPrintAdjust} onChange={(event)=>{
                                    if(event.target.checked)
                                    {
                                        setIsPrintAdjust(true)
                                    }else{
                                        setIsPrintAdjust(false)
                                    }

                                }} />} label={itemSelect.product_type === "C" ? 'หนังสือแจ้งสงวนสิทธิ์เรียกค่าปรับ' : 'หนังสือแจ้งสิทธิ์เรียกค่าปรับ'} />}
                                { toBoolean(itemSelect.is_reserved_adjust) && <FormControlLabel control={<Checkbox color="primary" defaultValue={isPrintReservedAdjust} onChange={(event)=>{
                                    if(event.target.checked)
                                    {
                                        setIsPrintReservedAdjust(true)
                                    }else{
                                        setIsPrintReservedAdjust(false)
                                    }

                                }} />} label="หนังสือแจ้งสงวนสิทธิ์การปรับ" />}
                            </FormGroup>
                        </Grid>}
                        <Grid>
                        {/* {itemSelect && itemSelect.status !== 'COMPLELE' && <Typography  color='secondary'>{"ใบงานยังไม่ Complete สามารถพิมพ์ได้เฉพาะไฟล์ตัวอย่าง"}</Typography>} */}
                        </Grid>
                        <Grid item xs={12}>
                            <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickPreviewComplete}>
                                <i className="icon btn-order-check-green" />
                                <span className="sp-btn-icon-label">ยืนยัน</span>
                            </a>
                        </Grid>
                    </Grid>
                </CustomDialog>
      </Grid>
    </Grid>
  );
};

AdjustmentTable.propTypes = {
  className: PropTypes.string,
  dataTable_Adjustment: PropTypes.array.isRequired
};

export default AdjustmentTable;




